<template>
  <modal
        v-if="switchs"
        ref="modal"
        id="agSwitchModal"
        class="modal-container"
        styles="display:flex; flex-direction:column; padding:15px;"
        :draggable=true
        :resizable=true
        v-model="showSwitchModal"
        name="switchsModal"
        drag="drag"
        content-class="modal-content"
        resize="resize"
        width="75%"
        height="85%"
        :shiftX=.5
        :shiftY=0
        :fit-parent="true"
        :resize-directions="['br']"
        :clickToClose="false"
        :key="reload"
        @keyup.enter.native="saveButton_click"
        >
        <div class="header">
          <h4 v-if="disableUI" class="agModal-title">View Switch</h4>
          <h4 v-else class="agModal-title">Edit Switch</h4>
          <hr/>
        </div>
        <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
        <div class="agInputGroup agInputGroupCentered">
      <label>Source:</label>
      <b-input type="text" v-model="srcStr" autocomplete="false" disabled></b-input>
    </div>
    <b-input-group size="md" style="padding:14px;" prepend="Name">
      <b-input type="text" v-model="agSwitch.name" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <b-input-group size="md" style="padding:14px;" prepend="Description">
      <b-input type="text" v-model="agSwitch.description" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <hr />
    <div class="agInputGroup agInputGroupCentered">
      <label>Field:</label>
      <b-form-select 
        class="agLargeInput" 
        v-model="agSwitch.field" 
        :disabled="disableUI"
        @change="field_change">
        <optgroup v-for="(field, key) in values" :key="key" :label="key">
          <option
            v-for="(option, index) in field"
            :key="index"
            :value="option.value"
          >{{option.text}}</option>
        </optgroup>
      </b-form-select>
    </div>
    <hr />
    <div v-for="(agCase, index) in agSwitch.cases" :key="index" class="agSwitchModal-case">
      <div style="display:flex; margin-bottom: 13px;">
        <div style="display:flex; justify-content:center;">
        <label v-if="index==agSwitch.cases.length - 1" class="agSwitchModal-caseLabel">Default Label:</label>
          <label v-else class="agSwitchModal-caseLabel">Case {{index + 1}} Label:</label>
      </div>
        <b-input :key="'cases-' + index + 1 + '-' + reloadCases" :value="agCase.caseName" @change="saveCaseName($event,index)" maxlength=15 style="width:200px;height:30px; margin-left: 2%;"></b-input>
      </div>
      <b-button
        v-if="index!=agSwitch.cases.length - 1"
        class="agSwitchModal-deleteCaseButton agDeleteButton agTextButton"
        :disabled="disableUI"
        @click="deleteCaseButton_click(index)">
        Delete
      </b-button>
      <div v-if="index!=agSwitch.cases.length -1" style="display:flex; position: static; margin-left: 96px;">
       <div style="margin-top:12px; margin-right: 94px; margin-bottom: 10px;">
         {{agSwitch.field.field}}
       </div>
      <div v-if="index!=agSwitch.cases.length - 1" class="agInputGroup agInputSubGroup">
        <div class="agInputGroup agInputGroupInline">
          <b-form-select v-model="agCase.comparator" :options="comparators" :disabled="disableUI"></b-form-select>
        </div>
        <div
          v-if="agCase.comparator != 'null' && agCase.comparator != 'notNull'"
          class="agInputGroup agInputGroupInline">
          <ag-input-select
            :key="'cases-' + index + '-' + reloadCases"
            :useSubInput="true"
            :inputModel="agCase.value.value"
            :selectModel="agCase.value.field"
            :workflow="workflow"
            :groups="values"
            :width="400"
            :disabled="disableUI"
            @input_keyup="caseValueInput_keyup($event, agCase)"
            @select_change="caseValueSelect_change($event, agCase)"
          ></ag-input-select>
        </div>
      </div>
      </div>
      <div class="agInputGroup agInputSubGroup">
        <b-table
          :key="'mods-' + index + '-' + reloadMods"
          class="agSwitchModal-modTable"
          :fields="modHeaders"
          :items="agCase.mods"
          :disabled="disableUI"
          borderless
          outlined
          small>
          <template #cell(field)="data">
            <b-form-select
              v-model="data.item.field"
              class="agSwitchModal-modTableField"
              :disabled="disableUI"
              @change="modField_change($event, agCase, data.index)">
              <optgroup v-for="(field, key) in fields" :key="key" :label="key">
                <option
                  v-for="(option, index) in field"
                  :key="index"
                  :value="option.value">
                  {{option.text}}
                </option>
              </optgroup>
            </b-form-select>
          </template>
          <template #cell(operator)="data">
            <b-form-select 
              v-model="data.item.operator"               
              class="agSwitchModal-modTableOperator"
              :options="operators" 
              :disabled="disableUI">
            </b-form-select>
          </template>
          <template #cell(value)="data">
            <ag-input-select
              :key="'modValues-' + index + '-' + reloadMods"
              :useSubInput="true"
              :inputModel="data.item.value.value"
              :selectModel="data.item.value.field"
              :workflow="workflow"
              :groups="values"
              :width="375"
              :disabled="disableUI"
              @input_keyup="modValueInput_keyup($event, agCase, data.index)"
              @select_change="modValueSelect_change($event, agCase, data.index)"
            ></ag-input-select>
          </template>
          <template #cell( )="data">
            <b-button
              v-if="data.index != agCase.mods.length - 1"
              class="agSwitchModal-deleteModButton agDeleteButton agImageButton"
              :disabled="disableUI"
              @click="deleteModButton_click(agCase, data.index)">
              <fa icon="times" />
            </b-button>
          </template>
        </b-table>
        <div class="agInputGroup agInputGroupCentered">
          <label>Destination:</label>
          <b-input type="text" :value="getNameForDest(agCase.dest)" autocomplete="false" disabled></b-input>
        </div>
      </div>
      <hr class="caseLine" />
    </div>
    <b-button
      id="agSwitchModal-addCaseButton"
      class="agTextButton"
      :disabled="disableUI"
      @click="addCaseButton_click">
      Add Case
    </b-button>
    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    </div>
    <div>
    <hr/>
      <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button
        class="agModal-buttonRight"
        variant="danger"
        :disabled="disableUI || isLoading"
        @click="deleteButton_click"
        style="margin-left:82%;"
      >Delete</b-button>
      <b-button
        class="agModal-buttonRight"
        variant="primary"
        :disabled="disableUI || isLoading"
        @click="saveButton_click"
        style="float: right;"
      >Save</b-button>
    </div>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Switch</h4>
      </template>
      Are you sure you want to delete switch
      <i>{{name}}</i>?
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
        class="agModal-buttonRight"
        variant="danger"
        @click="confirmDeleteButton_click"
        >Delete</b-button>
      </template>
    </b-modal>
    </modal>
</template>


<script>
// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Util from "src/util/util";
import { randomBytes } from "crypto";
import _ from 'lodash';

export default {
  name: "ag-switch-modal",
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },
  components: {
    "ag-input-select": InputSelect
  },
  data() {
    return {
      showSwitchModal: false,
      reload:0,
      switchs:false,
      agSwitch: null,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      reloadCases: 0,
      reloadMods: 0,
      fields: {},
      values: {},
      modHeaders: ["field", "operator", "value", " "],
      comparators: [
        { value: "equal", text: "equals" },
        { value: "notEqual", text: "does not equal" },
        { value: "contains", text: "contains" },
        { value: "notContains", text: "does not contain" },
        { value: "less", text: "less than" },
        { value: "lessEqual", text: "less than or equal to" },
        { value: "greaterEqual", text: "greater than or equal to" },
        { value: "greater", text: "greater than" },
        { value: "null", text: "is null or undefined" },
        { value: "notNull", text: "is not null or undefined" }
      ],
      operators: [
        { value: "set", text: "set" },
        { value: "append", text: "append" },
        { value: "prepend", text: "prepend" }
      ]
    };
  },
  computed: {

    name() {
      if (this.agSwitch.name) {
        return this.agSwitch.name;
      }
      return this.agSwitch.shortname;
    },

    srcStr() {
      if (!this.agSwitch.src || this.agSwitch.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.agSwitch.src.length; i++) {
        var src = this.agSwitch.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    }
  },
  watch: {
    reloadCases() {
      this.reloadMods++;
    }
  },

  mounted() {},

  methods: {
    // UI Events
    saveCaseName(e,index){
        this.agSwitch.cases[index].caseName = e; 
    },
    async saveButton_click() {
      this.modalMessage = "";

      // remove last, empty row for each case
      for (var i = 0; i < this.agSwitch.cases.length; i++)
        this.agSwitch.cases[i].mods.pop();  
        
      var node = {
        object: this.agSwitch,
        type: "switch"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "swtich",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
      // resinsert last rows in mods
      this.checkModRows();
    },

    cancelButton_click() {
      for (var i = 0; i < this.agSwitch.cases.length; i++)
        this.agSwitch.cases[i].mods.pop();
        this.$modal.hide('switchsModal');
        this.switchs = false;
      },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.agSwitch,
        type: "switch"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    addCaseButton_click() {
      var agCase = {
        comparator: "equal",
        value: {
          field: null,
          value: null
        },
        mods: [
          {
            field: null,
            child: null,
            operator: "set",
            value: {
              field: null,
              value: null
            }
          }
        ]
      };
      this.agSwitch.cases = Util.insertInArray(
        this.agSwitch.cases,
        this.agSwitch.cases.length - 1,
        agCase
      );
      this.reloadCases++;
    },

    deleteCaseButton_click(index) {
      this.agSwitch.cases = Util.removeFromArrayByIndex(
        this.agSwitch.cases,
        index
      );
      this.reloadCases++;
    },

    field_change(value) {
      if (value && value.field == "-- None --")
        this.agSwitch.field = null;
    },

    caseValueInput_keyup(value, agCase) {
      agCase.value.value = value;
      agCase.value.field = null;
    },

    caseValueSelect_change(value, agCase) {
      if (value.field == "-- None --")
        agCase.value.field = null;
      else
        agCase.value.field = value;
      agCase.value.value = null;
    },

    modField_change(value, agCase, index) {
      let mod = agCase.mods[index];
      if (value.field == "-- None --")
        mod.field= null;
      else
        mod.field = value;

      this.checkModRows();
    },

    modValueInput_keyup(value, agCase, index) {
      let mod = agCase.mods[index];
      mod.value.value = value;
      mod.value.field = null;
      this.checkModRows();
    },

    modValueSelect_change(value, agCase, index) {
      let mod = agCase.mods[index];
      if (value.field == "-- None --")
        mod.value.field = null;
      else
        mod.value.field = value;

      mod.value.value = null;
      this.checkModRows();
      this.reloadMods++;
    },

    deleteModButton_click(agCase, index) {
      agCase.mods = Util.removeFromArrayByIndex(agCase.mods, index);
      this.checkModRows();
      this.reloadMods++; // manually rerender mods tables there's UI using specific indexes
    },

    // emitted events

    // other
    show() {
      this.setSwitch();
      this.switchs = true;
      setTimeout(() => {
        this.$modal.show('switchsModal',{ draggable: true });
        this.reset();
      }, 250);
    },

    hide() {
      this.$modal.hide('switchsModal');
      this.switchs = false;    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      if (!this.agSwitch.field) {
        this.agSwitch.field = {};
      }

      this.checkModRows(); // to add empty row to end of all cases
      this.setFields();
      this.setValues();
      this.reloadCases++;
    },

    setSwitch() {
      if(this.node && this.node.type == "switch") 
        this.agSwitch = this.workflow.switches.find((object) => object._id == this.node.object._id);
      else
        this.agSwitch = null;
    },

    setFields() {
      this.fields = {
        " ": [{
            value: { object: "", field: "-- None --" },
            text: "-- None --"
      }]};
      var outputFields = Util.getOutputFields(this.$store, this.workflow);
      var optionGroups = Util.fieldsToOptionGroups(outputFields);
      Object.assign(this.fields, optionGroups);
    },

    setValues() {
      this.values = {
        " ": [{
            value: { object: "", field: "-- None --" },
            text: "-- None --"
      }]};
      var inputFields = Util.getInputFields(this.$store, this.workflow);
      var optionGroups = Util.fieldsToOptionGroups(inputFields);
      Object.assign(this.values, optionGroups);
    },

    getNameForDest(dest) {
      if (dest) return dest.shortname;
      return "";
    },

    // ensures there is one empty row at the end of each mod table
    checkModRows() {
        for (var i = 0; i < this.agSwitch.cases.length; i++) {
          var agCase = this.agSwitch.cases[i];
          var modsToRemove = [];
          for(var j = 0; j < agCase.mods.length; j++) {
            var mod = agCase.mods[j];
            if(this.isModEmpty(mod))
              modsToRemove.push(mod);
          }

          agCase.mods = agCase.mods.filter(a => modsToRemove.indexOf(a) < 0);

          // add empty row as last mod
           var newMod = {
            field: null,
            child: null,
            operator: "set",
            value: {
              field: null,
              value: null
            }
          };
          agCase.mods.push(newMod);
        }
    },

    isModEmpty(mod) {
      if(!mod.field && (!mod.value || (!mod.value.field && !mod.value.value)))
        return true;
      return false;
    },
  }
};
</script>


<style scoped lang="css">
#agSwitchModal-fieldInputs,
#agSwitchModal-fieldInputs .agInputGroup {
  margin-bottom: 0px;
}

.caseLine {
  width: 85%;
  margin-left: 12.5%;
}

#agSwitchModal-addCaseButton {
  display: block;
  margin: 25px auto;
  font-size: 18px;
}

.agSwitchModal-deleteCaseButton {
  position: absolute;
  right: 25px;
  font-size: 16px;
}

.agSwitchModal-deleteModButton {
  margin: 5px;
  font-size: 20px;
}

.agSwitchModal-caseLabel {
  font-weight: bold;
  color: gray;
}

.agSwitchModal-case .agInputGroup {
  margin-bottom: 10px;
}

.agSwitchModal-case table {
  margin-top: 10px;
  margin-bottom: 15px;
}

.agSwitchModal-modTable {
  text-align: center;
  width: 1000px;
}

.agSwitchModal-modTableField {
  width: 375px;
  display: inline-block;
}
.agSwitchModal-modTableOperator {
  width: 150px;
  display: inline-block;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/SwitchModal.vue